import { render, staticRenderFns } from "./CheckboxesBoolean.vue?vue&type=template&id=304c43ef&"
import script from "./CheckboxesBoolean.vue?vue&type=script&lang=js&"
export * from "./CheckboxesBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports